import type { ReactNode } from 'react';

export const symbol_badminton: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M332-409q58 1 98.5-40.5T471-550q0-31-14-58.5T420-658q-40-39-90.5-61T223-741q-37 0-60 18.5T140-669q0 60 21 115.5t65 97.5q22 20 49 33.5t57 13.5Zm290-381 153-73q14-7 27.5.5T818-839l9 90q1 10-4 18t-13 12l-98 47q-8 4-17.5 2.5T678-678l-64-64q-11-11-8.5-26t16.5-22Zm193 205q-15 6-32 .5T751-605q-5-5-3.5-10.5t6.5-8.5l72-34q4-2 7.5 0t4.5 7q4 26-2.5 43T815-585ZM332-348q-42 0-79.5-17.5T185-412q-52-51-78.5-118T80-669q0-63 39-97.5T223-801q68 0 129.5 26.5T461-700q30 31 48 69t18 81q0 32-9.5 62.5T490-431l287 288q9 9 9 21t-9 21q-9 9-21 9t-21-9L449-387q-25 20-55 29.5t-62 9.5Zm-26-227Z"
		/>
	</svg>
);
